import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { MenuDownIcon } from 'assests/GmsIcons';
import React from 'react';

type optionType = {
    name: string,
    onClick: Function
}

type propType = {
    options:optionType[],
    name: string,
    disabled?: boolean
}

const ButtonDropDown = (props:propType) => {
  const { showMenu, ref, handleClick } = useClickOutside();

  return (
    <React.Fragment>   
      <div className='tw-flex'>
        {/* CBM dark pass (okf/rules § 4.6): paint moved onto --ds-* roles, markup
            and testids untouched. The old #EBECF0 active/hover, tw-bg-white grounds
            and #172B4D/black inks were light-only literals; the label's
            `tw-text-[#091E42 tw-text-sm]` had a SPACE inside the arbitrary value —
            one class that never compiled — replaced by the two honest classes.
            MenuDownIcon bakes stroke #8E8E93, so it follows the ink via
            icon-follow-ink. */}
        <div ref={ref} className='tw-relative tw-bg-surface'>
          <button  data-testid="cbm-rule-builder-menu-btn" onClick={props?.disabled ? ()=>{}: handleClick} className={`${showMenu ? 'tw-bg-surface-hover tw-border' : ''} ${props?.disabled ? "hover:tw-cursor-not-allowed":"hover:tw-bg-surface-hover"}  tw-border tw-border-edge tw-p-2 tw-rounded-[4px] tw-flex flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
            <button data-testid="cbm-rule-builder-index-button-1" disabled={props?.disabled} className={`tw-text-sm tw-font-normal tw-w-[100%]  tw-text-ink`}>
              <span className='tw-mt-2 tw-font-semibold tw-text-ink'>{props?.name}</span>
            </button>
            <span className='icon-follow-ink tw-text-ink-secondary tw-flex tw-items-center'><MenuDownIcon/></span>
          </button>
          {showMenu && <div className={`tw-origin-top-right tw-absolute tw-mt-1 tw-w-max tw-mx-3 tw-rounded-[4px] tw-bg-surface-raised tw-ring-1 tw-ring-edge`}>
            <div className={`tw-py-1 tw-text-left`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
              {props?.options?.map((option:optionType) => (
                <React.Fragment key={option?.name} >
                  <div role="button" data-testid="cbm-rule-builder-index-div-1" onClick={() => {option?.onClick(); handleClick()}}  className={`tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-2 hover:tw-bg-surface-hover`}>
                    <div className={`tw-flex tw-items-center `}>
                      <label className={`tw-ms-2 tw-text-sm tw-text-ink`}>{option?.name}</label>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>}
        </div>
      </div>
  </React.Fragment>
  )
}

export default ButtonDropDown
